angular
  .module('fca-used')
  // WARNING: keep breakpoints in sync with style/_variables.scss
  .constant('BREAKPOINTS', {
    PHONE_PORTRAIT: {
      MIN: 0,
      MAX: 480
    },
    TABLET_PORTRAIT: {
      MIN: 481,
      MAX: 768
    },
    DESKTOP: {
      MIN: 769,
      MAX: Number.MAX_VALUE
    }
  });
